import Input from "../../../../components/Input/Input";
import React from "react";

const Date = ({id, formik, settings = {}}) => {
    return (
        <Input
            name={id}
            label={settings.title}
            type="date"
            required={settings.required}
            description={settings.description}
            formik={formik}
            layout="vertical"
        />
    )
};

export default Date;